class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// Keep ordinary catalogue searches focused on products currently available.
// Uses Shopify's native search option; never changes price, stock or checkout.
(() => {
  const option = 'options[unavailable_products]';
  const searchUrl = value => {
    const url = new URL(value, location.href);
    return url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search\/?$/i.test(url.pathname) ? url : null;
  };
  const prepareForm = form => {
    const url = searchUrl(form.action);
    if (!url || form.querySelector('input[name="' + option + '"]')) return;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = option; input.value = 'hide';
    form.append(input);
  };
  const prepareLink = link => {
    const url = searchUrl(link.href);
    if (url && !url.searchParams.has(option)) {
      url.searchParams.set(option, 'hide'); link.href = url.toString();
    }
  };
  const prepare = () => {
    document.querySelectorAll('form').forEach(prepareForm);
    document.querySelectorAll('a[href]').forEach(prepareLink);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
  document.addEventListener('submit', event => {
    if (event.target instanceof HTMLFormElement) prepareForm(event.target);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link) prepareLink(link);
  }, true);
  const current = searchUrl(location.href);
  if (current && current.searchParams.has('q') && !current.searchParams.has(option)) {
    current.searchParams.set(option, 'hide'); location.replace(current.toString());
  }
})();
